import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { title?: string };

function base(props: IconProps) {
  const { className = "h-4 w-4", title, ...rest } = props;
  return { className, title, ...rest };
}

export function InstagramIcon(props: IconProps) {
  const { title, ...p } = base(props);
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
      {...p}
    >
      {title ? <title>{title}</title> : null}
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function TikTokIcon(props: IconProps) {
  const { title, ...p } = base(props);
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
      {...p}
    >
      {title ? <title>{title}</title> : null}
      <path d="M16.5 3c.45 1.8 1.78 3.4 3.5 3.85V9.4c-1.55-.05-2.93-.55-4.1-1.45v6.7a5.55 5.55 0 1 1-5.55-5.55c.32 0 .63.03.93.08v2.74a2.85 2.85 0 1 0 1.97 2.71V3h3.25Z" />
    </svg>
  );
}

export function XIcon(props: IconProps) {
  const { title, ...p } = base(props);
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
      {...p}
    >
      {title ? <title>{title}</title> : null}
      <path d="M18.244 2H21l-6.52 7.45L22 22h-6.78l-4.71-6.18L4.93 22H2.17l6.98-7.97L2 2h6.93l4.25 5.62L18.244 2Zm-1.19 18h1.62L7.04 4H5.3l11.755 16Z" />
    </svg>
  );
}

export function LinkedInIcon(props: IconProps) {
  const { title, ...p } = base(props);
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
      {...p}
    >
      {title ? <title>{title}</title> : null}
      <path d="M20.45 3H3.55A.56.56 0 0 0 3 3.56v16.88c0 .31.25.56.55.56h16.9c.3 0 .55-.25.55-.56V3.56A.56.56 0 0 0 20.45 3ZM8.34 18.34H5.67V9.75h2.67v8.59ZM7 8.58a1.55 1.55 0 1 1 0-3.1 1.55 1.55 0 0 1 0 3.1Zm11.34 9.76h-2.67v-4.18c0-1 .02-2.28-1.39-2.28-1.4 0-1.61 1.09-1.61 2.21v4.25h-2.67V9.75h2.56v1.17h.04c.36-.68 1.23-1.39 2.53-1.39 2.7 0 3.2 1.78 3.2 4.09v4.72Z" />
    </svg>
  );
}

export function FacebookIcon(props: IconProps) {
  const { title, ...p } = base(props);
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
      {...p}
    >
      {title ? <title>{title}</title> : null}
      <path d="M14 9h3V6h-3c-1.66 0-3 1.34-3 3v2H8v3h3v7h3v-7h3l1-3h-4V9c0-.55.45-1 1-1Z" />
    </svg>
  );
}

export function YouTubeIcon(props: IconProps) {
  const { title, ...p } = base(props);
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
      {...p}
    >
      {title ? <title>{title}</title> : null}
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.97C18.88 4 12 4 12 4s-6.88 0-8.59.45A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.97C5.12 20 12 20 12 20s6.88 0 8.59-.45a2.78 2.78 0 0 0 1.95-1.97A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58ZM10 15.5v-7l6 3.5-6 3.5Z" />
    </svg>
  );
}
